// minimize product gallery on scroll
(function($) {
  // Пропускаем эффект для Android-чехлов (Samsung, Xiaomi и т.д.)
  if (document.body.classList.contains('no-sticky-gallery')) return;

  const stickyElement = document.querySelector('.container-fluid-mobile .col-6:first-child');
  if (!stickyElement) return;
  const stickyTop = stickyElement.offsetTop;

  window.addEventListener('scroll', () => {
    const isStuck = window.scrollY - 50 >= stickyTop;
    const isStuckTop = window.scrollY >= stickyTop;

    if (isStuck) {
      stickyElement.classList.add('is-stuck');
    } else {
      stickyElement.classList.remove('is-stuck');
    }

    if (!isStuckTop) {
      // console.log(window.scrollY,stickyTop);
      $('.tt-mobile-product-slider')[0].slick.refresh();
    }
  });


})(jQuery);
// minimize product gallery on scroll


// translate product options
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const domain = window.location.hostname;

    const translations = {
      "incadeworld.com": {
        "Тип кейсу": "Case type",
        "Колір телефону": "Phone color"
      },
      "pl.incadeworld.com": {
        "Тип кейсу": "Typ etui",
        "Колір телефону": "Kolor telefonu"
      }
    };

    const currentTranslations = translations[domain];
    if (!currentTranslations) return;

    document.querySelectorAll(".rio-product-option-title").forEach(el => {
      if (el.classList.contains("translated")) return;

      const span = el.querySelector(".rio-product-option-title-option-value");

      if (span) {
        const fullText = el.textContent;
        const spanText = span.textContent;
        const labelText = fullText.replace(spanText, "").trim().replace(/:$/, "");

        const translated = currentTranslations[labelText];
        if (translated) {
          // Просто добавляем перевод перед значением
          const labelSpan = document.createElement("span");
          labelSpan.className = "rio-product-option-title-translated";
          labelSpan.textContent = translated + ": ";

          el.insertBefore(labelSpan, span);
          el.classList.add("translated");
        }
      } else {
        const labelText = el.textContent.trim().replace(/:$/, "");
        const translated = currentTranslations[labelText];
        if (translated) {
          el.innerHTML = `<span class="rio-product-option-title-translated">${translated}</span>` + el.innerHTML;
          el.classList.add("translated");
        }
      }
    });
  });
})();
// translate product options

// update price on mobile
(function () {
  const mobilePrice = document.querySelector('.tt-price--mobile');
  const desktopPrice = document.querySelector('.tt-price--desktop');
  const productOptions = document.querySelectorAll('.rio-options [data-option-value]');

  window.addEventListener('load', () => {
    
    if (productOptions) {
      mobilePrice.innerHTML = desktopPrice.innerHTML;
      productOptions.forEach(option => {
        option.addEventListener('click', () => {
          setTimeout(() => {
          mobilePrice.innerHTML = desktopPrice.innerHTML;            
          }, 200);
        })
      })
    }
  });
  

  
})();
// update price on mobile
